import React from "react";
import { ResourceContextProvider, Create } from "react-admin";
import resourceNames from "../../../../common/data/resourceNames";
import { RouteComponentProps } from "react-router-dom";
import { CustomResourceRouteParams } from "../../../../common/types";
import { EditActions } from "../../../common/form/FormActions";
import { DriverLogRemarkForm } from "./DriverLogRemarkForm";
import "./DriverLogAddRemark.css";

interface Props extends RouteComponentProps<CustomResourceRouteParams> {
  onClose: () => void;
  onSuccess: () => void;
  timeZone?: string | null;
}

export const DriverLogAddRemark = ({ timeZone, ...props }: Props) => {
  return (
    <ResourceContextProvider value={`${resourceNames.HOS_EVENTS}`}>
      <div id="driver-log-add-remark-container">
        <Create
          title=" "
          basePath={`/${resourceNames.HOS_DRIVER_LOG_VIEW}/${props.match.params.driverId}/${props.match.params.date}`}
          resource={`${resourceNames.HOS_EVENTS}`}
          onSuccess={() => {
            props.onSuccess();
          }}
          actions={<EditActions onClose={props.onClose} />}>
          <DriverLogRemarkForm timeZone={timeZone} />
        </Create>
      </div>
    </ResourceContextProvider>
  );
};
